import { GrowthPerformance } from "./applications/analytics/executive/GrowthPerformance/GrowthPerformance";
import { ComparativeSales } from "./applications/analytics/executive/ComparativeSales/ComparativeSales";
import { ComparativeSalesPerformance } from "./applications/analytics/executive/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { PerformanceByProductGroup } from "./applications/analytics/executive/PerformanceByProductGroup/PerformanceByProductGroup";
import { CustomerSales } from "./applications/analytics/executive/CustomerSales/CustomerSales";
import { CustomerGroupProduct } from "./applications/analytics/executive/CustomerGroupProduct/CustomerGroupProduct";

// Region dashboard when the user login is Executive
import { ExecutiveRegionComparativeSalesPerf } from "./applications/analytics/executiveregion/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { ExecutiveRegionPerformanceByProductGroup } from "./applications/analytics/executiveregion/PerformanceByProductGroup/PerformanceByProductGroup";
import { ExecutiveRegionComparativeSales } from "./applications/analytics/executiveregion/ComparativeSales/ComparativeSales";
import { ExecutiveRegionGrowthPerformance } from "./applications/analytics/executiveregion/GrowthPerformance/GrowthPerformance";
import { ExecutiveRegionCustomerSales } from "./applications/analytics/executiveregion/CustomerSales/CustomerSales";
import { ExecutiveRegionalCustomerGroupProduct } from "./applications/analytics/executiveregion/CustomerGroupProduct/CustomerGroupProduct";

import { DistrictComparativeSalesPerf } from "./applications/analytics/district/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { DistrictPerformanceByProductGroup } from "./applications/analytics/district/PerformanceByProductGroup/PerformanceByProductGroup";
import { DistrictComparativeSales } from "./applications/analytics/district/ComparativeSales/ComparativeSales";
import { DistrictGrowthPerformance } from "./applications/analytics/district/GrowthPerformance/GrowthPerformance";
import { DistrictCustomerSales } from "./applications/analytics/district/CustomerSales/CustomerSales";
import { DistrictCustomerGroupProduct } from "./applications/analytics/district/CustomerGroupProduct/CustomerGroupProduct";

import { AgentComparativeSalesPerf } from "./applications/analytics/agent/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { AgentPerformanceByProductGroup } from "./applications/analytics/agent/PerformanceByProductGroup/PerformanceByProductGroup";
import { AgentComparativeSales } from "./applications/analytics/agent/ComparativeSales/ComparativeSales";
import { AgentGrowthPerformance } from "./applications/analytics/agent/GrowthPerformance/GrowthPerformance";
import { AgentCustomerSales } from "./applications/analytics/agent/CustomerSales/CustomerSales";
import { AgentCustomerGroupProduct } from "./applications/analytics/agent/CustomerGroupProduct/CustomerGroupProduct";

import { RegionComparativeSalesPerf } from "./applications/analytics/region/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { RegionPerformanceByProductGroup } from "./applications/analytics/region/PerformanceByProductGroup/PerformanceByProductGroup";
import { RegionComparativeSales } from "./applications/analytics/region/ComparativeSales/ComparativeSales";
import { RegionGrowthPerformance } from "./applications/analytics/region/GrowthPerformance/GrowthPerformance";
import { RegionCustomerSales } from "./applications/analytics/region/CustomerSales/CustomerSales";
import { RegionalCustomerGroupProduct } from "./applications/analytics/region/CustomerGroupProduct/CustomerGroupProduct";

import { DistributorComparativeSalesPerf } from "./applications/analytics/distributor/ComparativeSalesPerformance";

import { CustomerComparativeSalesPerf } from "./applications/analytics/customer/ComparativeSalesPerformance";

import { ItemsComparativeSalesPerf } from "./applications/analytics/item/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { DistrictItemsComparativeSalesPerf } from "./applications/analytics/item/ComparativeSalesPerformance/DistrictComparativeSalesPerformance";
import { AgentItemsComparativeSalesPerf } from "./applications/analytics/item/ComparativeSalesPerformance/AgentComparativeSalesPerformance";

import { ProductGroupComparativeSalesPerf } from "./applications/analytics/p-group/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { DistrictProductGroupComparativeSalesPerf } from "./applications/analytics/p-group/ComparativeSalesPerformance/DistrictComparativeSalesPerformance";
import { AgentProductGroupComparativeSalesPerf } from "./applications/analytics/p-group/ComparativeSalesPerformance/AgentComparativeSalesPerformance";

import { OPMIColorScheme } from "../themes/theme-opmi";

import { ApplicationBrand, MenuItems, ApplicationItems } from "../client-configuration";
import { ColorScheme } from "../themes/theme-default";
import { AgentPlanningDashboard } from "./applications/analytics/agent/PlanningDashboard/PlanningDashboard";
import { SupervisorPlanningDashboard } from "./applications/analytics/supervisor/PlanningDashboard/PlanningDashboard";

const exportApplication = {
  "applications": [
    {
      "id": 1,
      "name": "Comparative Sales Performance"
    },
    {
      "id": 3,
      "name": "Performance by Product Group"
    },
    {
      "id": 4,
      "name": "Comparative Sales"
    },
    {
      "id": 7,
      "name": "Customer Group Product"
    },
    {
      "id": 5,
      "name": "Growth Performance"
    },
    {
      "id": 6,
      "name": "Customer Sales"
    }
  ]
}

const exportApplicationCustomer = {
  "applications": [
    {
      "id": 1,
      "name": "Comparative Sales Performance"
    }
  ]
}

export const accountMapping = {
  Default: 0,
  Customer: 1,
  Doctor: 2,
  Agent: 3,
  Institution: 4
}

export const statusMapping = {
  pending: 0,
  success: 1,
  missed: 2,
  inprogress: 3,
  recovered: 4,
  advanced: 5
}

export const planWorksheetStatusMapping = {
  ForSubmission: 1,
  AwaitingApproval: 2,
  UpdateRequired: 3,
  Approved: 4,
  Rejected: 5,
  Closed: 6
}

export const eventTypes = {
  Organizational: 1,
  Holidays: 2, //Reference ID refers to Holiday ID 
  External: 3,
  Leave: 5,
  Recurring: 6
}

export const activityClassification = {
  Regular: 1,
  Event: 2,
  System: 255,
}

export const activityTypes = {
  Regular: 1,
  WorkWith: 2,
  Contextual: 4
}

export const orderStatus = {
  Draft: 0,
  Submitted: 1,
  Processing: 2,
  Delivered: 3,
  Cancelled: 4
}

export const statusDisplayNames = {
  0: "Pending",
  1: "Success",
  2: "Missed",
  3: "In Progress",
  4: "Recovered",
  5: "Advanced",
  8: "Success Joint Call",
  9: "Recovered Joint Call",
  10: "Advanced Joint Call"
};

export const planStatusDisplayNames = {
  1: "For Submission",
  2: "Awaiting Approval",
  3: "Closed",
  4: "Approved",
  5: "Rejected",
  6: "Update Required",
};

export const sessionType = {
  Pending: 0,
  Regular: 1,
  Advanced: 5,
  PastDue: 6,
  Recovery: 4,
  Incidental: 11
}

export const SessionTag = {
  advanced: 2,
  pastdue: 1,
  recovered: 3,
  incidental: 4
}

export const SyncStatusMap = {
  create: 1,
  update: 2,
  done: 3
}

export const LocationMap = {
  samples: 0,
  stockRoom: 1,
  shelf: 2
}

export const SessionItemAvailability = {
  Carried: 1,
  ForDeletion: 3,
  Deleted: 4,
  OutOfStock: 5
}

export const FileStatus = {
  pending: 0,
  notInLocal: 1,
  downloaded: 2
}

export const Announcements = [
  {
    "ID": 1,
    "Date": "2025-06-01T00:00:00",
    "Message": "Dr. Santos will be covering for Dr. Reyes in General Surgery.",
    "Priority": 2
  },
  {
    "ID": 2,
    "Date": "2025-06-01T00:00:00",
    "Message": "Staff meeting scheduled at 2:00 PM in Conference Room B.",
    "Priority": 1
  },
  {
    "ID": 3,
    "Date": "2025-06-02T00:00:00",
    "Message": "Happy birthday to Dr. Lim!",
    "Priority": 1
  },
  {
    "ID": 4,
    "Date": "2025-06-02T00:00:00",
    "Message": "Dr. Chen is on-call for the Emergency Department.",
    "Priority": 1
  },
  {
    "ID": 5,
    "Date": "2025-06-03T00:00:00",
    "Message": "Nursing staff training at 10:00 AM in Hall A.",
    "Priority": 1
  },
  {
    "ID": 6,
    "Date": "2025-06-03T00:00:00",
    "Message": "Warm wishes to Nurse Angela on her birthday!",
    "Priority": 1
  },
  {
    "ID": 7,
    "Date": "2025-06-04T00:00:00",
    "Message": "Dr. Mendoza is handling all Cardiology rounds.",
    "Priority": 1
  },
  {
    "ID": 8,
    "Date": "2025-06-04T00:00:00",
    "Message": "Quality Assurance review session at 4:00 PM.",
    "Priority": 1
  },
  {
    "ID": 9,
    "Date": "2025-06-05T00:00:00",
    "Message": "Join us in celebrating Dr. Villanueva’s birthday today.",
    "Priority": 1
  },
  {
    "ID": 10,
    "Date": "2025-06-05T00:00:00",
    "Message": "Dr. Ramos will assist in Outpatient Consultations.",
    "Priority": 1
  }
]

export const File = [
  {
    "ID": 1,
    "FileType": 1,
    "FileName": "NJPPK Detailer_1-9",
    "Extension": ".pdf",
    "SearchTags": "invoice,april,finance",
    "Status": 1,
    "StoragePath": "/files/2023/NJPPK Detailer_1-9.pdf",
    "AccessUrl": "/files/NJPPK Detailer_1-9.pdf",
    "SizeClassification": "large",
    "UploadBy": 1,
    "UploadedDate": "2023-04-11T09:00:00",
    "ApprovedBy": 1,
    "ApprovedDate": "2023-04-11T10:30:00",
    "UserType": 3
  },
  {
    "ID": 2,
    "FileType": 1,
    "FileName": "NJ PPJ Sore T - p1",
    "Extension": ".png",
    "SearchTags": "meeting,minutes,march",
    "Status": 1,
    "StoragePath": "/files/2023/NJ PPJ Sore T - p1.png",
    "AccessUrl": "/files/NJ PPJ Sore T - p1.png",
    "SizeClassification": "small",
    "UploadBy": 2,
    "UploadedDate": "2023-03-28T14:15:00",
    "ApprovedBy": 3,
    "ApprovedDate": "2023-03-30T11:00:00",
    "UserType": 3
  },
  {
    "ID": 3,
    "FileType": 3,
    "FileName": "NJ PPK Cough - p1",
    "Extension": ".png",
    "SearchTags": "product,image,sample",
    "Status": 1,
    "StoragePath": "/images/products/sample.jpg",
    "AccessUrl": "/files/NJ PPK Cough - p1.png",
    "SizeClassification": "small",
    "UploadBy": 6,
    "UploadedDate": "2023-04-05T13:45:00",
    "ApprovedBy": 1,
    "ApprovedDate": "2023-04-06T09:15:00",
    "UserType": 3
  },
  {
    "ID": 4,
    "FileType": 4,
    "FileName": "NJ PPK Cough Preps Table",
    "Extension": ".jpg",
    "SearchTags": "logo,company,branding",
    "Status": 1,
    "StoragePath": "/branding/logo.png",
    "AccessUrl": "/files/NJ PPK Cough Preps Table.jpg",
    "SizeClassification": "small",
    "UploadBy": 7,
    "UploadedDate": "2023-04-10T16:30:00",
    "ApprovedBy": 8,
    "ApprovedDate": "2023-04-11T10:00:00",
    "UserType": 3
  }
]

const nullData = {
  "sections": [],
  "palettes": [],
  "themes": []
}

export const ExecutiveData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": ComparativeSalesPerformance,
  "3": PerformanceByProductGroup,
  "4": ComparativeSales,
  "5": GrowthPerformance,
  "6": CustomerSales,
  "7": CustomerGroupProduct,
  applicationdashboard: exportApplication,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const DistrictData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": DistrictComparativeSalesPerf,
  "3": DistrictPerformanceByProductGroup,
  "4": DistrictComparativeSales,
  "5": DistrictGrowthPerformance,
  "6": DistrictCustomerSales,
  "7": DistrictCustomerGroupProduct,
  applicationdashboard: exportApplication,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const AgentData = {
  sections: AgentPlanningDashboard,
  colorScheme: ColorScheme,
};

export const SupervisorData = {
  sections: SupervisorPlanningDashboard,
  colorScheme: ColorScheme,
};

export const ManagerData = {
  sections: AgentPlanningDashboard,
  colorScheme: ColorScheme,
};

export const ExecutiveRegionalData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": ExecutiveRegionComparativeSalesPerf,
  "3": ExecutiveRegionPerformanceByProductGroup,
  "4": ExecutiveRegionComparativeSales,
  "5": ExecutiveRegionGrowthPerformance,
  "6": ExecutiveRegionCustomerSales,
  "7": ExecutiveRegionalCustomerGroupProduct,
  applicationdashboard: exportApplication,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const RegionalData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": RegionComparativeSalesPerf,
  "3": RegionPerformanceByProductGroup,
  "4": RegionComparativeSales,
  "5": RegionGrowthPerformance,
  "6": RegionCustomerSales,
  "7": RegionalCustomerGroupProduct,
  applicationdashboard: exportApplication,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const DistributorData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": DistributorComparativeSalesPerf,
  "3": nullData,
  "4": nullData,
  "5": nullData,
  "6": nullData,
  "7": nullData,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const CustomerData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": CustomerComparativeSalesPerf,
  "3": nullData,
  "4": nullData,
  "5": nullData,
  "6": nullData,
  "7": nullData,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const AgentProductData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": AgentItemsComparativeSalesPerf,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const DistrictProductData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": DistrictItemsComparativeSalesPerf,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const ProductData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": ItemsComparativeSalesPerf,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const ProductGroupData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": ProductGroupComparativeSalesPerf,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const AgentProductGroupData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": AgentProductGroupComparativeSalesPerf,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const DistrictProductGroupData = {
  brand: ApplicationBrand,
  application: ApplicationItems,
  "1": DistrictProductGroupComparativeSalesPerf,
  applicationdashboard: exportApplicationCustomer,
  colorScheme: OPMIColorScheme,
  'menuItems': MenuItems,
};

export const DefaultData = {
  sections: AgentPlanningDashboard,
  colorScheme: ColorScheme,
};